var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryDotRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_3",
    "data-name": "\\uD0C0\\uC6D0 3",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    fill: "#cb3063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryDotRed);
export default __webpack_public_path__ + "static/media/history_dot_red.36b9a12dfd6227a1755cefbc77a25a51.svg";
export { ForwardRef as ReactComponent };